const messages = {
  en: {
    required: "Field required",
    email_required: "Email required",
    email_invalid: "Email invalid",
    phone_invalid: "Phone number invalid",
  },
  fr: {
    required: "Champ requis",
    email_required: "Courriel requis",
    email_invalid: "Adresse courriel invalide",
    phone_invalid: "Numéro de téléphone invalide",
  },
};

export default messages;
